import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import CategoryCardPhysicalListing from "Pages/category/testCategory";
// import testCategory from "Pages/category/testCategory";
import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllNewCollectionsWithFilter,
  getAllSellItem,
  getCategories,
  getSubCategories,
} from "store/actions";
import { Oval } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { converCryptoToDollar } from "helpers/constants";
import abstract from "./subcatImages/abstract.png";
import cowboy from "./subcatImages/cowboy.png";
import cubism from "./subcatImages/cubism.png";
import fantasy from "./subcatImages/fantasy.png";
import impressionism from "./subcatImages/impressionism.png";
import landscape from "./subcatImages/landscape.png";
import military from "./subcatImages/military.png";
import nativeAmerican from "./subcatImages/nativeAmerican.png";
import representational from "./subcatImages/representational.png";
import seascape from "./subcatImages/seascape.png";
import space from "./subcatImages/space.png";
import surrealism from "./subcatImages/surrealism.png";
import defaultSubcatImage from "./subcatImages/portraitImg.png";
import modernArt from "./subcatImages/modernArt.png";
import maritime from "./subcatImages/maritime.png";
import stillLife from "./subcatImages/stillLife.png";
import spiritual from "./subcatImages/spiritual.png";
import popArt from "./subcatImages/popArt.png";
import dragon from "./subcatImages/dragon.png";
import aerial from "./subcatImages/aerial.png";
import airSpace from "./subcatImages/air&Space.png";
import americanWest from "./subcatImages/americanWest.png";
import astrophotography from "./subcatImages/astrophotography.png";
import campingHunting from "./subcatImages/camping&Hunting.png";
import city from "./subcatImages/city.png";
import fashion from "./subcatImages/fashion.png";
import floral from "./subcatImages/floral.png";
import land from "./subcatImages/land.png";
import other from "./subcatImages/other.png";
import portrait from "./subcatImages/portrait.png";
import sea from "./subcatImages/sea.png";
import sports from "./subcatImages/sports.png";
import storm from "./subcatImages/storm.png";
import architecture from "./subcatImages/architecture.png";
import wildlife from "./subcatImages/wildlife.png";
import allimg from "./subcatImages/All.png";

export default function SearchResult(props) {
  const { HideData, getLikedPost, isLiked } = props;
  const { categories } = useSelector((state) => state?.categories);
  const [state, setState] = useState("all");
  const [page, setpage] = useState("category");
  const [name, setName] = useState("63a3f8ca3afc27eac9e49068");
  const [search, setSearch] = useState("");
  const [subcatData, setSubcatData] = useState([]);
  const { subCategory } = useSelector((state) => state?.categories);
  const [searchCatData, setSearchCatData] = useState([]);
  const sellItemitems = useSelector((state) => state?.SellItems?.sellItems);
  console.log("sellitems",sellItemitems);
  const totalSellItem = useSelector((state) => state?.SellItems?.totalSellItem);
  const { AllNewCollectionsWithFilter } = useSelector(
    (state) => state?.collections
  );
  const [isSubCat, setIsSubCat] = useState(false);
  const { loading } = useSelector((state) => state?.SellItems);
  const dispatch = useDispatch();
  const location = useLocation();
  const [all, setAll] = useState(false);
  const [nftData, setNftData] = useState([]);
  const [catName, setCatName] = useState("Traditional Art");
  const [items, setItems] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [catState, setCatSate] = useState("Traditional Art");
  const [ovalLaoding, setOvalLaoding] = useState(true);
  const [minprice, setMinPrice] = useState(undefined);
  const [maxprice, setMaxPrice] = useState(undefined);
  const [excRate, setExcRate] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const [subcateActive, setsubcateActive] = useState("All");
  const [sortBy, setSortBy] = useState("Sort By");
  const [onScroll, setIsOnScroll] = useState(false);
  const myRef = useRef(null);
  const [subcatFromDb, setSubcatFromDb] = useState({
    Landscape: landscape,
    Representational: representational,
    Cowboy: cowboy,
    Seascape: seascape,
    Impressionism: impressionism,
    Abstract: abstract,
    Surrealism: surrealism,
    Fantasy: fantasy,
    Space: space,
    Maritime: maritime,
    "Still Life": stillLife,
    "Modern Art": modernArt,
    Cubism: cubism,
    Spiritual: spiritual,
    "Pop Art": popArt,
    Dragon: dragon,
    "Native American": nativeAmerican,
    Military: military,
    Aerial: aerial,
    "Air and Space": airSpace,
    "American West": americanWest,
    Astrophotography: astrophotography,
    "Camping/Hunting": campingHunting,
    "Architecture/City": city,
    Fashion: fashion,
    Floral: floral,
    Land: land,
    Other: other,
    Portrait: portrait,
    Sea: sea,
    Sports: sports,
    Storm: storm,
    "City Scenes/Architecture": architecture,
    Wildlife: wildlife,
  });
  const [filter, setfilter] = useState({
    limit: 12,
    orderBy: "created_date",
    order: -1,
    page: 1,
    collectedAuthor: "",
    author: "",
    createdAuthor: "",
    collectionId: "",
    minPrice: undefined,
    maxPrice: undefined,
    fields: [
      {
        fieldName: "categoty_id",
        fieldValue: "63a3f8ca3afc27eac9e49068",
      },
      {
        fieldName: "subcategory_id",
        fieldValue: "",
      },
    ],
    sellType: [],
    fileType: [],
    collections: [],
    isVarified: false,
    getNew: false,
    isMore: false,
  });

  useEffect(() => {
    const collCallback = (res) => {};
    dispatch(
      getAllNewCollectionsWithFilter({ limit: Number.MAX_VALUE }, collCallback)
    );
  }, [dispatch]);

  const converterCryptoToDollar = async () => {
    let oneDollarinOneMatic = 1 - (await converCryptoToDollar(1, "MATIC"));
    setExcRate(oneDollarinOneMatic);
  };

  useEffect(() => {
    converterCryptoToDollar();
  }, []);

  useEffect(() => {
    setCollectionBySearch(AllNewCollectionsWithFilter);
  }, [AllNewCollectionsWithFilter]);

  useEffect(() => {
    setpage(location.pathname.split("/")[1]);
    console.log('location',location);
    const nftType= location.state?.isPhysical;
    if(nftType && nftType === 'physical'){
      let obj = {
        fieldName: "sellType",
        fieldValue: nftType,
      };
      var arr = filter.sellType;
      arr?.push(obj);
      setfilter((p) => ({ ...p, sellType: arr, page: 1 }));
    }
    
  }, [location]);


  useEffect(() => {
    const callback = (res) => {
      setOvalLaoding(false);
      setIsOnScroll(false);
    };
    setOvalLaoding(true);
    console.log("filter data ankit", filter)
    dispatch(getAllSellItem(filter, callback));
  }, [filter, dispatch]);


  useEffect(() => {
    dispatch(getCategories());
    const subcatCallback = (res) => {
      setOvalLaoding(false);
    };
    dispatch(getSubCategories({}, subcatCallback));
  }, [dispatch]);

  useEffect(() => {
    const dss = subCategory.filter(
      (item) => item?.category?.name === "Traditional Art"
    );

    if (name !== "64ed723878520f06b3c4bbc0") {
      setSubcatData(
        subCategory.filter((item) => item?.category?.name === "Traditional Art")
      );
    } else {
      setSubcatData(
        subCategory.filter((item) => item?.category?.name === "Photography")
      );
    }
  }, [subCategory, name]);

  const handleCategoryEvent = (catname, name) => {
    if (name !== "All") {
      setIsSubCat(false);

      setName(name);
      const x = items.filter((x) => x?.categoty_id === name);
      setCatName(catname);
      setState("all");
    }
  };
  useEffect(() => {
    const data = [...nftData, ...sellItemitems];
    function removeDuplicatesById(arr) {
      const seenIds = new Set();
      return arr.filter((item) => {
        if (seenIds.has(item._id)) {
          return false;
        } else {
          seenIds.add(item._id);
          return true;
        }
      });
    }
    const uniqueItems = removeDuplicatesById(data);

    setNftData(uniqueItems);
  }, [sellItemitems]);

  useEffect(() => {
    if (search === "") {
      setSearchCatData(items);
    } else {
      setSearchCatData(
        items.filter((item) => {
          return search.toLowerCase() === ""
            ? item
            : item?.name?.toLowerCase().includes(search.toLowerCase());
        })
      );
    }
  }, [search, items]);

  useEffect(() => {
    const stateMap = {
      "Traditional Art": { ActiveArtClass: true },
      Landscape: { ActiveLandscapeClass: true },
      "Still Life": { ActiveStillLifeClass: true },
      Photography: { ActivePhotographyClass: true },
      Abstract: { ActiveAbstractClass: true },
      Wildlife: { ActiveWildlifeClass: true },
    };

    setCatSate(stateMap[catName] || stateMap["Traditional Art"]);
  }, [catName]);

  const fetchDataOnScroll = () => {
    setIsOnScroll(true);
    setfilter((prev) => ({ ...prev, page: activePage + 1 }));
    setActivePage(activePage + 1);
  };

  useEffect(() => {
    setNftData([]);
    setfilter((p) => ({ ...p, page: 1 }));
  }, []);
  const [collectionBySearch, setCollectionBySearch] = useState([]);
  useEffect(() => {
    setCheckboxesChecked();

    if (search === "") {
      setCheckboxesChecked();
      setCollectionBySearch(AllNewCollectionsWithFilter);
    } else {
      setCheckboxesChecked();
      setCollectionBySearch(
        AllNewCollectionsWithFilter?.filter((item) => {
          return search === ""
            ? item
            : item?.name.toLowerCase().includes(search.toLowerCase());
        })
      );
    }
  }, [search, AllNewCollectionsWithFilter, filter?.collections]);
  function setCheckboxesChecked() {
    const checkboxes = document.querySelectorAll(
      '.CustomeCheckBox input[type="checkbox"]'
    );
    checkboxes.forEach((checkbox) => {
      if (filter?.collections?.includes(checkbox.id)) {
        checkbox.checked = true;
      }
    });
  }
  const [collection_id, setCollectionId] = useState([]);
  const collectionChnageHandler = (checked, collection_id) => {
    if (checked) {
      setCollectionId((prevCollectionId) => [
        ...prevCollectionId,
        collection_id,
      ]);
    } else {
      setNftData([]);
      setCollectionId((prevCollectionId) => [
        ...filter?.collections.filter((item) => item !== collection_id),
      ]);
    }
    var element = document.getElementById("targetElement");
    var headerOffset = 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    setOvalLaoding(true);
    if (collection_id.length === 1) {
      setNftData([]);
    }
    setfilter((p) => ({ ...p, collections: collection_id, page: 1 }));
    setIsReset(false);
  }, [collection_id]);

  const handleListingType = (checked, sellTypes) => {
    setOvalLaoding(true);
    setIsReset(false);
    if (checked) {
      setNftData([]);
      let obj = {
        fieldName: "sellType",
        fieldValue: sellTypes,
      };
      var arr = filter.sellType;
      arr?.push(obj);
      setfilter((p) => ({ ...p, sellType: arr, page: 1 }));
    } else {
      setNftData([]);
      var arr = filter.sellType;
      arr = filter?.sellType?.filter((item) => item.fieldValue !== sellTypes);
      setfilter((p) => ({ ...p, sellType: arr, page: 1 }));
    }
  };

  const aliders = () => {
    const sliderList = document.querySelector(".subcategoryNew");
    const buttons = document.querySelectorAll(".buttons");
    const maxScrollLeft = sliderList.scrollWidth - sliderList.clientWidth;
    const sliderScrollbar = document.querySelector(" .slider-scrollbar");
    const scrollbarThumb = sliderScrollbar.querySelector(".scrollbar-thumb");
    // Handle scrollbar thumb drag
    scrollbarThumb.addEventListener("mousedown", (e) => {
      const startX = e.clientX;
      const thumbPosition = scrollbarThumb.offsetLeft;
      const maxThumbPosition =
        sliderScrollbar.getBoundingClientRect().width -
        scrollbarThumb.offsetWidth;

      // Update thumb position on mouse move
      const handleMouseMove = (e) => {
        const deltaX = e.clientX - startX;
        const newThumbPosition = thumbPosition + deltaX;

        // Ensure the scrollbar thumb stays within bounds
        const boundedPosition = Math.max(
          0,
          Math.min(maxThumbPosition, newThumbPosition)
        );
        const scrollPosition =
          (boundedPosition / maxThumbPosition) * maxScrollLeft;

        scrollbarThumb.style.left = `${boundedPosition}px`;
        sliderList.scrollLeft = scrollPosition;
      };

      // Remove event listeners on mouse up
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      // Add event listeners for drag interaction
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    });

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const direction = btn.id === "pre-slide" ? -1 : 1;
        const scrollAmount = sliderList.clientWidth * direction;

        sliderList.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });
    });

    const handalBtns = () => {
      buttons[0].style.display = sliderList.scrollLeft <= 0 ? "none" : "block";
      buttons[1].style.display =
        sliderList.scrollLeft >= maxScrollLeft ? "none" : "block";
    };
    // Update scrollbar thumb position based on image scroll
    const updateScrollThumbPosition = () => {
      const scrollPosition = sliderList.scrollLeft;
      const thumbPosition =
        (scrollPosition / maxScrollLeft) *
        (sliderScrollbar.clientWidth - scrollbarThumb.offsetWidth);
      scrollbarThumb.style.left = `${thumbPosition}px`;
    };

    sliderList.addEventListener("scroll", () => {
      handalBtns();
      updateScrollThumbPosition();
    });
  };

  const handlePriceChange = (type, price) => {
    if (type === "minPrice") {
      setNftData([]);
      setMinPrice(price);
    } else {
      setNftData([]);
      setMaxPrice(price);
    }
  };
  const apiCallForPriceFilter = () => {
    setOvalLaoding(true);
    setIsReset(false);
    setfilter((p) => ({
      ...p,
      minPrice: minprice,
      maxPrice: maxprice,
      page: 1,
    }));
  };
  useEffect(() => {
    apiCallForPriceFilter();
  }, [minprice, maxprice]);

  useEffect(() => {
    window.addEventListener("load", aliders);
  }, [subcatData]);
  const handlePriceSorting = (sortOrder) => {
    setNftData([]);
    setOvalLaoding(true);
    setIsReset(false);
    if (sortOrder == 0) {
      setSortBy(0);
      setfilter((p) => ({ ...p, orderBy: "created_date", order: -1, page: 1 }));
    } else {
      setSortBy(sortOrder === -1 ? "Price Low To High" : "Price High To Low");
      setfilter((p) => ({
        ...p,
        orderBy: "nft_id.price",
        order: sortOrder,
        page: 1,
      }));
    }
  };
  const handleScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleClearFilter = (categoryNmae = "Traditional Art") => {
    const checkboxes = document.querySelectorAll(
      '.CustomeCheckBox input[type="checkbox"]'
    );
    var sellTypeCheckBoxesFixed = document.getElementById("BuyNow");
    var sellTypeCheckBoxesAuction = document.getElementById("Auction");
    sellTypeCheckBoxesFixed.checked = false;
    sellTypeCheckBoxesAuction.checked = false;
    checkboxes.forEach((checkbox) => {
      if (filter?.collections?.includes(checkbox.id)) {
        checkbox.checked = false;
      }
    });

    setCollectionId([]);
    setState("all");
    setCatName(
      categoryNmae === "Traditional Art" ? "Traditional Art" : "Photography"
    );
    setMinPrice("");
    setMaxPrice("");
    setSearch("");
    setIsReset(false);
    setItems([]);
    setNftData([]);
    setActivePage(1);
    setSortBy("Sort By");
    setsubcateActive("");
    setsubcateActive("All");
    setNftData([]);
    handleCategoryEvent(
      categoryNmae,
      categoryNmae === "Traditional Art"
        ? "63a3f8ca3afc27eac9e49068"
        : "64ed723878520f06b3c4bbc0"
    );
    setfilter((p) => ({
      ...p,
      limit: 12,
      orderBy: "created_date",
      order: -1,
      page: 1,
      collectedAuthor: "",
      author: "",
      createdAuthor: "",
      collectionId: "",
      minPrice: "",
      maxPrice: "",
      fields: [
        {
          fieldName: "categoty_id",
          fieldValue:
            categoryNmae === "Traditional Art"
              ? "63a3f8ca3afc27eac9e49068"
              : "64ed723878520f06b3c4bbc0",
        },
        {
          fieldName: "subcategory_id",
          fieldValue: "",
        },
      ],
      sellType: [],
      fileType: [],
      collections: [],
      isVarified: false,
      getNew: false,
      isMore: false,
    }));
  };
  const handleAllClick = () => {
    setsubcateActive("All");
    var catId = "64ed723878520f06b3c4bbc0";
    if (catName === "Traditional Art") catId = "63a3f8ca3afc27eac9e49068";
    setfilter((p) => ({
      ...p,
      fields: [
        { fieldName: "categoty_id", fieldValue: catId },
        { fieldName: "subcategory_id", fieldValue: "" },
      ],
    }));
  };
  useEffect(() => {
    console.log('filter',filter);
    
  }, [filter]);
  return (
    <div className="position-relative">
      {ovalLaoding === true && onScroll === false && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Header />
      {/* <div className="container-fluid profileBox dashboardprofile">
        <Row>
          <Col lg={12}>
            <h1>
            Art Genre
            </h1>
          </Col>
        </Row>
      </div> */}
      <section className="upcoming-section artgenreMain browseCategory position-relative padding_Custome">
        <Container>
          <Row>
            <Col lg={12}>
              <div
                className={
                  "DigitalArtcollection-head currentauction-head d-flex align-items-center justify-content-center artgenpage mb-3"
                }
              >
                <div className="text-center">
                  <h2>Explore</h2>
                  <p>Dive into the Top Digital Artwork Categories</p>
                </div>
              </div>

              <div className="artgenTabNew">
                <button
                  className={catState?.ActiveArtClass === true ? "active" : ""}
                  onClick={() => {
                    handleClearFilter("Traditional Art");
                    // setOvalLaoding(true);
                    // setIsReset(false)
                    // setItems([]);
                    // setNftData([]);
                    // setActivePage(1);
                    // handleCategoryEvent(
                    //   "Traditional Art",
                    //   "63a3f8ca3afc27eac9e49068"
                    // );
                    // setfilter((prev) => ({
                    //   ...prev,
                    //   page: 1,
                    //   fields: [
                    //     {
                    //       fieldName: "categoty_id",
                    //       fieldValue: "63a3f8ca3afc27eac9e49068",

                    //     },
                    //     {
                    //       fieldName: "subcategory_id",
                    //       fieldValue: "",
                    //     },
                    //   ],
                    // }));
                  }}
                >
                  {" "}
                  Traditional Art
                </button>
                <button
                  className={
                    catState?.ActivePhotographyClass === true ? "active" : ""
                  }
                  onClick={() => {
                    handleClearFilter("Photography");
                  }}
                >
                  Photography
                </button>
              </div>

              {page !== "artist" && (
                <div className="categoryBox mb-4 mt-4 d-none">
                  <div
                    className={
                      catState?.ActiveArtClass === true
                        ? "Boxin1 art active"
                        : "Boxin1 art"
                    }
                  >
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/cate_art.svg"} alt=""></img>
                      </div>
                      <h3>Traditional Art</h3>
                    </div>
                  </div>

                  <div
                    className={
                      catState?.ActivePhotographyClass === true
                        ? "Boxin1 cryptopunks active"
                        : "Boxin1 cryptopunks"
                    }
                  >
                    <div className="contBox">
                      <div className="imgBox">
                        <img src={"images/svg/camera.svg"} alt=""></img>
                      </div>
                      <h3>Photography</h3>
                    </div>
                  </div>
                </div>
              )}
            </Col>
            <Col lg={12}>
              <div className="mt-4">
                <div className="slidercateMaien">
                  <div className="previous buttons " id="pre-slide">
                    <div className="btnsInn" onClick={() => aliders()}>
                      <i class="fa-solid fa-chevron-left"></i>
                    </div>
                  </div>

                  <div class="subcategoryNew">
                    <div
                      class={
                        "cateBoxInn " +
                        (subcateActive === "All" ? "active" : "")
                      }
                      onClick={handleAllClick}
                    >
                      <div class="cateInn2">
                        <img src={allimg} alt="" />
                        <div class="overlayCate">All</div>
                      </div>
                    </div>
                    {subcatData.length > 0 &&
                      subcatData?.map((item, idx) => (
                        <div
                          class={
                            "cateBoxInn " +
                            (subcateActive === item?.name ? "active" : "")
                          }
                        >
                          <div class="cateInn2">
                            <img
                              src={
                                subcatFromDb[item?.name]
                                  ? subcatFromDb[item?.name]
                                  : defaultSubcatImage
                              }
                              alt=""
                            />
                            <div
                              class="overlayCate"
                              onClick={() => {
                                setOvalLaoding(true);
                                setNftData([]);
                                setsubcateActive(item?.name);
                                setIsReset(false);
                                setfilter((p) => ({
                                  ...p,
                                  page: 1,
                                  fields: [
                                    {
                                      fieldName: "categoty_id",
                                      fieldValue: "",
                                    },
                                    {
                                      fieldName: "subcategory_id",
                                      fieldValue: item?._id,
                                    },
                                  ],
                                }));
                              }}
                            >
                              {item?.name}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div
                    className="Next buttons"
                    id="next-slide"
                    onClick={() => aliders()}
                  >
                    <div className="btnsInn">
                      <i class="fa-solid fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
                <div class="slider-scrollbar">
                  <div class="scrollbar-track">
                    <div class="scrollbar-thumb"></div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="DigitalArtcollection-main artgenBoxNftN position-relative padding_Custome">
        <Container>
          <Row>
            <Col lg={3}>
              <div className="filterBg">
                <div className="filterHead">
                  <h2>Filter</h2>
                  {isReset === false && (
                    <button
                      className="clearFilter"
                      onClick={() => handleClearFilter("Traditional Art")}
                    >
                      <i class="fa-sharp fa-solid fa-filter-circle-xmark"></i>{" "}
                      Clear Filter
                    </button>
                  )}
                </div>
                <div className="filterBoxIn">
                  <h3>Listing Type</h3>
                  
                  <div className={`CustomeCheckBox filtercheckNew mt-2 mb-2`}>
                    <input
                      type="checkbox"
                      id="BuyNow"
                      onChange={(e) =>
                        handleListingType(e.target.checked, "fixed")
                      }
                    />{" "}
                    <label htmlFor="BuyNow"></label>
                    <span className="mb-0 cursor-pointer">Buy Now</span>
                  </div>

                  <div className="CustomeCheckBox filtercheckNew mb-2">
                    <input
                      type="checkbox"
                      id="Auction"
                      onChange={(e) =>
                        handleListingType(e.target.checked, "auction")
                      }
                    />{" "}
                    <label htmlFor="Auction"></label>
                    <span className="mb-0 cursor-pointer">Auction</span>
                  </div>

                  <div className="CustomeCheckBox filtercheckNew mb-2">
                    <input
                      type="checkbox"
                      checked={filter.sellType.some((item) => item.fieldValue === "physical")}
                      id="Physical"
                      onChange={(e) =>
                        handleListingType(e.target.checked, "physical")
                      }
                    />
                    <label htmlFor="Physical"></label>
                    <span className="mb-0 cursor-pointer">Physical</span>
                  </div>

                  {/* <div className="CustomeCheckBox filtercheckNew mb-2">
                    <input type="checkbox" id="NftPrint" onChange={(e) => handleListingType(e.target.checked, "nftPrint")} />{" "}
                    <label htmlFor="NftPrint"></label>
                    <span className="mb-0 cursor-pointer">Digital Artwork with Physical Print</span>
                  </div>
                  <div className="CustomeCheckBox filtercheckNew mb-2">
                    <input type="checkbox" id="PhysicalPrint" onChange={(e) => handleListingType(e.target.checked, "physicalPrint")} />{" "}
                    <label htmlFor="PhysicalPrint"></label>
                    <span className="mb-0 cursor-pointer">Physical Print only</span>
                  </div> */}
                </div>
                <div className="filterBoxIn">
                  <h3>Price</h3>
                  <div className="priceBox" onScroll={handleScroll}>
                    <h3>
                      <img
                        src="/images/svg/maticIcon.svg"
                        width="30"
                        height="30"
                        alt=""
                      />
                    </h3>
                    <input
                      type="number"
                      className="form-control"
                      value={filter?.minPrice}
                      placeholder="Minimum"
                      onChange={(e) =>
                        handlePriceChange("minPrice", e.target.value)
                      }
                    />
                    <div className="dashprice"></div>
                    <input
                      type="number"
                      className="form-control"
                      value={filter?.maxPrice}
                      placeholder="Maximum"
                      onChange={(e) =>
                        handlePriceChange("maxPrice", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="filterBoxIn">
                  <h3>Collection</h3>
                  <div className="form-group searchBoxfilter mt-3">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <img src="images/svg/searchIcon.svg" alt="" />
                  </div>
                  <div className="collectionReseult">
                    {collectionBySearch?.length > 0 &&
                      collectionBySearch
                        ?.sort((a, b) => a?.name.localeCompare(b?.name))
                        ?.map((item, idx) => (
                          <div
                            className="CustomeCheckBox filtercheckNew mb-2"
                            key={item?._id}
                          >
                            <input
                              type="checkbox"
                              id={item?._id}
                              onChange={(e) =>
                                collectionChnageHandler(
                                  e?.target?.checked,
                                  item?._id
                                )
                              }
                            />{" "}
                            <label htmlFor={item?._id}></label>
                            <span className="mb-0 cursor-pointer">
                              {item?.name}
                            </span>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="totalNFTbox" id="targetElement" ref={myRef}>
                <div className="selectBox ms-auto">
                  <select
                    value={sortBy}
                    onChange={(e) => handlePriceSorting(e.target.value)}
                  >
                    <option selected disabled>
                      Sort By
                    </option>
                    <option value={1}>Price Low To High</option>
                    <option value={-1}>Price High To Low</option>
                    <option value={0}>Recent Listing</option>
                  </select>
                </div>
              </div>
              <div className="digitailart-tabbing digitalartsNew  ">
                {page !== "artist" && (
                  <div className="tab-frame d-none mb-4">
                    {!HideData && (
                      <>
                        {categories && categories?.length > 0 && (
                          <>
                            <div className="filterbox">
                              <input name="tab" type="radio" checked={true} />
                              <label
                                onClick={() => {
                                  handleCategoryEvent("", "All");
                                  setOvalLaoding(true);
                                  setIsReset(false);
                                  setAll(true);
                                  setState("all");
                                  setItems([]);
                                  setNftData([]);
                                  setActivePage(1);
                                  if (catName === "Traditional Art") {
                                    setfilter((prev) => ({
                                      ...prev,
                                      page: 1,
                                      fields: [
                                        {
                                          fieldName: "categoty_id",
                                          fieldValue:
                                            "64ed723878520f06b3c4bbc0",
                                        },
                                        {
                                          fieldName: "subcategory_id",
                                          fieldValue: "",
                                        },
                                      ],
                                    }));
                                  } else if (catName === "Photography") {
                                    setIsReset(false);
                                    setfilter((prev) => ({
                                      ...prev,
                                      page: 1,
                                      fields: [
                                        {
                                          fieldName: "categoty_id",
                                          fieldValue:
                                            "64ed723878520f06b3c4bbc0",
                                        },
                                        {
                                          fieldName: "subcategory_id",
                                          fieldValue: "",
                                        },
                                      ],
                                    }));
                                  }
                                }}
                              >
                                All
                              </label>

                              {subcatData?.map((categoryItems, id) => {
                                return (
                                  <>
                                    <input
                                      key={id}
                                      type="radio"
                                      name="tab"
                                      checked={state === categoryItems?.name}
                                    />
                                    <label
                                      onClick={() => {
                                        setOvalLaoding(true);
                                        setIsReset(false);
                                        setItems([]);
                                        setNftData([]);
                                        setActivePage(1);
                                        setfilter((p) => ({
                                          ...p,
                                          page: 1,
                                          fields: [
                                            {
                                              fieldName: "categoty_id",
                                              fieldValue: "",
                                            },
                                            {
                                              fieldName: "subcategory_id",
                                              fieldValue: categoryItems?._id,
                                            },
                                          ],
                                        }));
                                        setState(categoryItems?.name);
                                      }}
                                    >
                                      {categoryItems?.name}
                                    </label>
                                  </>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}

                {(page === "category" || "art-genre") && (
                  <>
                    {nftData.length > 0 ? (
                      <>
                        <InfiniteScroll
                          dataLength={nftData.length} //This is important field to render the next data
                          next={fetchDataOnScroll}
                          className="infiniteScroll"
                          hasMore={nftData?.length < totalSellItem}
                          loader={<h3>Loading...</h3>}
                          endMessage={
                            <p style={{ textAlign: "center" }}>
                              <b>{""}</b>
                            </p>
                          }
                        >
                          <Row>
                            {nftData?.map((item, idx) => {
                              return (
                                <Col
                                  className="mb-4"
                                  key={idx}
                                  md={6}
                                  lg={4}
                                  xl={3}
                                >
                                  <CategoryCardPhysicalListing data={item} />
                                </Col>
                              );
                            })}
                          </Row>
                        </InfiniteScroll>
                      </>
                    ) : (
                      <>
                        <div className="text-center d-grid justify-content-center dataNotFound py-5">
                          <img
                            src={"../../images/svg/mpdatanft.svg"}
                            className="mb-4"
                            alt="Create collection"
                          />
                          <h3>No Artworks Available</h3>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
}
